export const GET_COURSE = 'dashboard/get_course';
export const GET_MY_COURSES = 'courses/get_my_courses';